const PrismicConfig = require("../prismic.config");
import prismicDOM from "prismic-dom";
export const prismicEndpoint = PrismicConfig.apiEndpoint;
import * as $js from "package-js";
import linkResolver from "./link-resolver";
import htmlSerializer from "./html-serializer.js";
export const fetchWorkItems = $js
  .getSingleDocByType(prismicEndpoint, "work_items")
  .then(async ({ data }) => {
    let allWorkItems = await $js.getAllDocs(prismicEndpoint);
    allWorkItems = allWorkItems.results
      .filter(doc => doc.type === "work_item")
      .map(workItem => {
        return { ...workItem.data, id: workItem.id };
      })
      .filter(workItem => workItem.publish);
    const orderedWorkItems = data.ordered_work_items.map(orderedWorkItem => orderedWorkItem.ordered_work_item);
    const workItems = [];
    orderedWorkItems.map(orderedWorkItem => {
      const orderedWorkItemIndex = allWorkItems.findIndex(
        workItem => workItem.id === orderedWorkItem.id
      );
      if (orderedWorkItemIndex !== -1) {
        const fuq = allWorkItems.splice(orderedWorkItemIndex, 1)[0]
        workItems.push(fuq);
      } 
    });
    workItems.map(workItem => {
      workItem.about = prismicDOM.RichText.asHtml(
        workItem.about,
        linkResolver,
        htmlSerializer
      );
    });
    const camelCasedWorkItems = $js.convertSnakeToCamel(workItems);
    return camelCasedWorkItems.filter(workItem => workItem.publish);
  })
  .catch(err => console.log(err));
